import Box from '@mui/material/Box';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import React from 'react';

const StoryblokCarouselTestimonialSlide = ({ blok }) => {
  const { testimonial } = blok;

  const hasTestimonial = testimonial && testimonial.length > 0;
  if (!hasTestimonial) return null;

  return (
    <Box {...storyblokEditable(blok)} key={blok._uid}>
      <StoryblokComponent blok={testimonial[0]} key={testimonial[0]._uid} />
    </Box>
  );
};

export default StoryblokCarouselTestimonialSlide;
